import request from '../utils/request';

export const qualityApi = {
  // 获取质检列表
  getQualityList: (params) => {
    return request({
      url: '/quality/list',
      method: 'get',
      params: {
        orderNumber: params.orderNumber,
        customerName: params.customerName,
        qualityStatus: params.qualityStatus,
        startTime: params.startTime,
        endTime: params.endTime,
        page: params.page,
        pageSize: params.pageSize
      }
    });
  },

  // 确认收货
  confirmReceipt: (id) => {
    return request({
      url: `/quality/confirm-receipt/${id}`,
      method: 'post'
    });
  },

  // 送检
  sendForInspection: (id) => {
    return request({
      url: `/quality/send-inspection/${id}`,
      method: 'post'
    });
  },

  // 质检不合格
  rejectQualityCheck: (id, data) => {
    return request({
      url: `/quality/reject/${id}`,
      method: 'post',
      data
    });
  }
}; 